import { capitalize } from "lodash";
import { useEffect } from "react";
import { Card, CardBody, CardTitle, Spinner } from "reactstrap";
import AutoFocusDiv from "../../../common/auto-focus-div";
import { AddressManagerDomain, useAddressState } from "../address-manager-context";
import useAddressApi from "../useAddressApi";
import BusinessEntity from "./business-entity";
import BusinessEntityTable from "./business-entity-table";

export default function BusinessEntityPane() {
  const { selectedDataId: addressId, subdomains = {} } = useAddressState();

  const { [AddressManagerDomain.BusinessEntities]: businessEntityState } = subdomains;
  const { dataSet: businessEntities, selectedDataId: selectedBusinessEntityId } = businessEntityState ?? {};

  const currentBusinessEntity = businessEntities?.find(item => item.id === selectedBusinessEntityId);

  const { getAssociatedBusinessEntities, busy } = useAddressApi();

  useEffect(() => {
    addressId && getAssociatedBusinessEntities(+addressId);
  }, [addressId]);

  if (busy) {
    return <Spinner className="container my-5" aria-busy="true" />;
  } else if (!businessEntities) {
    return <></>;
  }

  return (<>
    <Card>
      <CardBody>
        <CardTitle>
          Associated Business Entities
        </CardTitle>

        <BusinessEntityTable pageSize={10} />
      </CardBody>
    </Card>

    {currentBusinessEntity &&
      <BusinessEntity entityId={currentBusinessEntity.entityId} entityType={currentBusinessEntity?.entityType}>
        <Card aria-label="Business Entity Information">
          <CardBody>
            <CardTitle className="mb-0">
              <AutoFocusDiv trigger={currentBusinessEntity}>
                {capitalize(currentBusinessEntity?.entityType)}: {currentBusinessEntity?.entityName}
              </AutoFocusDiv>
            </CardTitle>

            <Spinner className="container my-5" aria-busy="true" />
          </CardBody>
        </Card>
      </BusinessEntity>
    }
  </>);
}
